import { Box, CardMedia, Typography, useMediaQuery, useTheme } from '@mui/material';
import SLPArtistsWhy1 from '../../assets/slpArtists/slpArtistsWhy1.png';
import SLPArtistsWhy2 from '../../assets/slpArtists/slpArtistsWhy2.png';
import SLPArtistsWhy3 from '../../assets/slpArtists/slpArtistsWhy3.png';
import ListArtstyleButton from './SLPArtistsListArtstyleButton';

const SLPArtistsWhy = () => {
  const theme = useTheme();
  const isMdOrBelow = useMediaQuery(theme.breakpoints.down('md'));
  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        background: '#000000',
        px: { xs: '24px', sm: 4 },
        pt: '1rem',
        mt: { xs: '50px' },
        [theme.breakpoints.down('md')]: {
          paddingTop: '0'
        }
      }}
    >
      {/* Main Heading */}
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          maxWidth: 1180,
          marginTop: '3rem',
          mb: 2,

          justifyContent: 'center',
          [theme.breakpoints.down('md')]: {
            marginTop: '2rem',
            maxWidth: '300px'
          }
        }}
      >
        <Typography
          fontFamily="Inter"
          variant="h4"
          sx={{
            fontWeight: 700,
            fontSize: { xs: '24px', sm: '32px', md: '40px' },
            color: '#ffffffff',
            mb: { xs: '16px', sm: 2, md: 4 },
            textAlign: 'center',
            width: { xs: '237px', sm: 'auto' },
            marginLeft: { xs: '24px', sm: '0' }
          }}
        >
          What Makes Saagas Different?
        </Typography>
        <Typography
          fontFamily="Inter"
          variant="h4"
          sx={{
            fontWeight: 500,
            fontSize: { xs: '16px', sm: '20px', md: '28px' },
            color: 'rgba(255, 255, 255, 1)',
            textAlign: 'center',
            mb: { xs: '20px' }
          }}
        >
          Ethical, Transparent, Artist-Centered
        </Typography>
      </Box>

      {/* Sections */}
      <Box
        sx={{
          [theme.breakpoints.down('md')]: {
            display: 'flex',
            flexDirection: 'column',
            gap: '1rem'
          }
        }}
      >
        {/* section 1 */}
        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', md: 'row' },
            width: '100%',
            maxWidth: 1260,
            height: { xs: 'auto', md: 464 },
            gap: '40px',
            alignItems: 'center',
            mb: 4,
            [theme.breakpoints.down('md')]: {
              mt: 0,
              mb: 0,
              gap: '5px'
            }
          }}
        >
          {/* Title - shows first on mobile, hidden on desktop in this position */}
          <Typography
            variant="h5"
            fontFamily="Inter"
            sx={{
              fontWeight: 600,
              lineHeight: '122%',
              fontSize: { xs: '20px', md: '29.03px' },
              color: '#FFFFFF',
              mt: 1,
              mb: 1,
              display: { xs: 'block', md: 'none' },
              textAlign: 'center'
            }}
          >
            Consent-Based Licensing
          </Typography>

          {/* Text content for desktop */}
          <Box
            sx={{
              flex: 1,
              display: { xs: 'none', md: 'flex' },
              flexDirection: 'column',
              maxWidth: '352px',
              alignItems: 'flex-start',
              textAlign: 'left'
            }}
          >
            <Typography
              variant="h5"
              fontFamily="Inter"
              sx={{
                fontWeight: 600,
                lineHeight: '122%',
                fontSize: '29.03px',
                color: '#c0c0c0',
                mt: 2
              }}
            >
              Consent-Based Licensing
            </Typography>
            <Typography
              fontFamily="Inter"
              sx={{
                fontWeight: 300,
                lineHeight: '25px',
                fontSize: '16.8px',
                color: '#C0C0C0',
                mt: 2,
                mb: 4
              }}
            >
              Nothing is trained or published without your explicit permission. You control every listing.
            </Typography>
          </Box>

          {/* Image */}

          <Box sx={{ flex: 2 }}>
            <CardMedia
              component="img"
              src={SLPArtistsWhy1}
              alt="Creator Image"
              sx={{
                width: '100%',
                maxWidth: 888,
                border: '1px solid #c0c0c0',
                borderRadius: '10px',
                // p: '0.2px'
              }}
            />
          </Box>

          {/* Description - shows last on mobile */}
          <Typography
            fontFamily="Inter"
            sx={{
              fontWeight: 300,
              lineHeight: '122%',
              fontSize: '14px',
              color: '#C0C0C0',
              mt: 2,
              mb: 2,
              display: { xs: 'block', md: 'none' },
              textAlign: 'center',
              // width: '352px'
            }}
          >
            Nothing is trained or published without your explicit permission. You control every listing.
          </Typography>
        </Box>

        {/* section 2 */}
        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', md: 'row' },
            width: '100%',
            maxWidth: 1260,
            height: { xs: 'auto', md: '464px' },
            gap: '40px',
            alignItems: 'center',
            mt: 11,
            mb: 4,
            [theme.breakpoints.down('md')]: {
              mt: 0,
              mb: 0,
              gap: '5px'
            }
          }}
        >
          {/* Title - shows first on mobile, hidden on desktop in this position */}
          <Typography
            variant="h5"
            fontFamily="Inter"
            sx={{
              fontWeight: 600,
              lineHeight: '25px',
              fontSize: '20px',
              color: 'rgba(255, 255, 255, 1)',
              mt: { xs: 2, md: 2, lg: 2 },
              mb: 1,
              display: { xs: 'block', md: 'none' },
              textAlign: 'center'
            }}
          >
            Compensation & Control: Get Paid and Monitor Usage
          </Typography>

          {/* Image */}
          <Box sx={{ flex: 2, backgroundColor: '#000000' }}>
            <Box
              component="img"
              src={SLPArtistsWhy2}
              alt="Creator Image"
              sx={{
                width: '100%',
                maxWidth: 888,
                border: '1px solid #c0c0c0',
                borderRadius: '10px'
              }}
            />
          </Box>

          {/* Text content for desktop */}
          <Box
            sx={{
              flex: 1,
              display: { xs: 'none', md: 'flex' },
              flexDirection: 'column',
              maxWidth: '352px',
              alignItems: 'flex-start',
              textAlign: 'left'
            }}
          >
            <Typography
              variant="h5"
              fontFamily="Inter"
              sx={{
                fontWeight: 600,
                lineHeight: '122%',
                fontSize: '29.03px',
                color: '#c0c0c0',
                mt: 2
              }}
            >
              Compensation & Control: Get Paid and Monitor Usage
            </Typography>
            <Typography
              variant="h5"
              fontFamily="Inter"
              sx={{
                fontWeight: 300,
                lineHeight: '122%',
                fontSize: '16.8px',
                color: '#C0C0C0',
                mt: 2,
                mb: 4
              }}
            >
              You set your own price and get paid for every image downloaded for personal or commercial use.{' '}
            </Typography>
          </Box>

          {/* Description - shows last on mobile */}
          <Typography
            variant="h5"
            fontFamily="Inter"
            sx={{
              fontWeight: 300,
              lineHeight: '122%',
              fontSize: '14px',
              color: '#C0C0C0',
              mt: 2,
              mb: 2,
              display: { xs: 'block', md: 'none' },
              textAlign: 'center',
              // width: '352px'
            }}
          >
            You set your own price and get paid for every image downloaded for personal or commercial use.{' '}
          </Typography>
        </Box>
      </Box>

      {/* section 3 */}
      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', md: 'row' },
          width: '100%',
          maxWidth: 1260,
          height: { xs: 'auto', md: 464 },
          gap: '40px',
          alignItems: 'center',
          mt: 10,
          mb: 4,
          [theme.breakpoints.down('md')]: {
            mt: 0,
            mb: 0,
            gap: '5px'
          }
        }}
      >
        {/* Title - shows first on mobile, hidden on desktop in this position */}
        <Typography
          variant="h5"
          fontFamily="Inter"
          sx={{
            fontWeight: 600,
            lineHeight: '25px',
            fontSize: '20px',
            color: '#FFFFFF',
            mt: { xs: 3, md: 2, lg: 2 },
            mb: 1,
            display: { xs: 'block', md: 'none' },
            textAlign: 'center'
          }}
        >
          Credit: Attribution Built-In
        </Typography>

        {/* Text content for desktop */}
        <Box
          sx={{
            flex: 1,
            display: { xs: 'none', md: 'flex' },
            flexDirection: 'column',
            maxWidth: '331px',
            alignItems: 'flex-start',
            textAlign: 'left'
          }}
        >
          <Typography
            variant="h5"
            fontFamily="Inter"
            sx={{
              fontWeight: 600,
              lineHeight: '122%',
              fontSize: '29.03px',
              color: '#c0c0c0',
              mt: 2
            }}
          >
            Credit: Attribution Built-In
          </Typography>
          <Typography
            variant="h5"
            fontFamily="Inter"
            sx={{
              fontWeight: 300,
              lineHeight: '25px',
              fontSize: '16.8px',
              color: '#C0C0C0',
              letterSpacing: '0px',
              mt: 2,
              mb: 4
            }}
          >
            Every image generated based on your art work includes visible credit and metadata linking back to you.
          </Typography>
        </Box>

        {/* Image */}
        <Box sx={{ flex: 2, backgroundColor: '#000000' }}>
          <Box
            component="img"
            src={SLPArtistsWhy3}
            alt="Creator Image"
            sx={{
              width: '100%',
              maxWidth: 888,
              border: '1px solid #c0c0c0',
              borderRadius: '10px',
              
            }}
          />
        </Box>

        {/* Description - shows last on mobile */}
        <Typography
          variant="h5"
          fontFamily="Inter"
          sx={{
            fontWeight: 300,
            lineHeight: '122%',
            fontSize: '14px',
            color: '#C0C0C0',
            letterSpacing: '0px',
            mt: 2,
            mb: 0,
            display: { xs: 'block', md: 'none' },
            textAlign: 'center',
            // width: '352px'
          }}
        >
          Every image generated based on your art work includes visible credit and metadata linking back to you.
        </Typography>
      </Box>

      {/* Footer Text */}
      <Box sx={{ maxWidth: 1300, mb: { xs: 0, md: '40px' }, px: { xs: 2 } }}>
        <Box
          display="flex"
          justifyContent="center"
          sx={{
            [theme.breakpoints.down('md')]: {
              mt: 0
            }
          }}
        >
          <ListArtstyleButton
            maxWidth={isMdOrBelow ? '131px' : '200px'}
            maxHeight={isMdOrBelow ? '49px' : '52px'}
            fontSize={isMdOrBelow ? '14px' : '16px'}
            padding={isMdOrBelow ? '8px 15px' : '16px 32px'}
            marginTop={{ xs: '40px', sm: '40px' }}
          />
        </Box>
        <Box
          sx={{
            paddingTop: { xs: '0', md: '2' },
            marginBottom: { xs: '80px', md: '0px' }
          }}
        ></Box>
      </Box>
    </Box>
  );
};

export default SLPArtistsWhy;
